const bufferToHex = (buffer: ArrayBuffer): string =>
  Array.from(new Uint8Array(buffer))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');

export const readFileAsArrayBuffer = (file: File): Promise<ArrayBuffer> => {
  if (typeof file.arrayBuffer === 'function') {
    return file.arrayBuffer();
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as ArrayBuffer);
    reader.onerror = () => reject(reader.error ?? new Error('Không thể đọc file.'));
    reader.readAsArrayBuffer(file);
  });
};

/** SHA-256 fingerprint for duplicate-import detection. */
export const computeFileFingerprint = async (file: File): Promise<string> => {
  const buffer = await readFileAsArrayBuffer(file);

  if (typeof crypto !== 'undefined' && crypto.subtle?.digest) {
    const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
    return bufferToHex(hashBuffer);
  }

  // Fallback when Web Crypto is unavailable (e.g. some test environments).
  let hash = 0;
  const bytes = new Uint8Array(buffer);
  for (let index = 0; index < bytes.length; index += 1) {
    hash = (hash * 31 + bytes[index]) >>> 0;
  }
  return `fallback-${hash.toString(16)}-${bytes.length}`;
};